import styled from "styled-components";

export const WalletDownloadStyle = styled.div`
    /*width: 620px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);*/
    display: grid;
    background: #fff;
    border-radius: 16px;
    overflow: hidden;
    line-height: 28px;
    .left{
        padding: 16px 38px 32px 32px;
        .content{
            color: #000;
        }
    }
    .right{
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 40px;
    }
`;

export const Title = styled.h3`
    font-size: 16px;
    font-weight: 600;
    line-height: 28px;
    /*margin-bottom: 1px;*/
    color: #000;
`;

export const WalletDownloadBtn = styled.a`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 40px;
    padding: 0 25px;
    box-sizing: border-box;
    background: #eeefef;
    color: #000;
    line-height: 40px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 400;
    margin-top: 32px;
    cursor:pointer;
    text-decoration: none;
    .walletIcon{
        width: 24px;
        height: 24px;
        margin-right: 24px;
    }
    .text{
        flex: 1;
    }
`;

export const IntrolItem = styled.div`
    display: flex;
    align-items: center;
    color: #000;
    &:not(:last-child){
        margin-bottom: 16px;
    }
    .icon-box{
        width: 14px;
        height: 14px;
        margin-right: 8px;
        .icon{
            vertical-align: top;
        }
    }
`;
